import styled from '@emotion/styled';
import { ErrorsContextProvider, ValidationErrors } from 'components';
import { ROUTING_PATHS } from 'const';
import { useIntParam } from 'hooks';
import { Modal } from 'semantic-ui-react';
import { Link, generatePath, useLocation, useNavigate } from 'react-router';
import { Button, toast } from '@britishcouncil/react-admin';
import { useCallback, useEffect, useMemo } from 'react';
import { parseServerErrors } from 'utils';
import { speakingSessionStore } from 'store';

export const RemoveSpeakingSession = () => {
  const sessionId = useIntParam('sessionId');
  const location = useLocation();
  const { speakingSessionDetails, speakingSessions } = ROUTING_PATHS;
  const [removeSession, { isSuccess, error: removeError, isLoading: isConfirming, reset }] =
    speakingSessionStore.service.useRemoveSpeakingSessionMutation();
  const navigate = useNavigate();
  const errors = useMemo(() => parseServerErrors(removeError), [removeError]);

  const goToSpeakingSessions = useCallback(() => {
    navigate(generatePath(speakingSessions.absolutePath, { sessionId }));
  }, [navigate, speakingSessions.absolutePath, sessionId]);

  useEffect(() => {
    if (isSuccess) {
      toast({
        type: 'success',
        title: 'Success',
        message: 'Speaking session removed',
      });
      goToSpeakingSessions();
      reset();
    }
  }, [goToSpeakingSessions, isSuccess, sessionId, reset]);

  return (
    <ErrorsContextProvider generalErrors={errors}>
      <Modal open size="tiny">
        <Modal.Header>Remove Speaking session</Modal.Header>
        <Modal.Content>
          <S.ValidationErrors />
          <p>Would you like to remove this Speaking session?</p>
        </Modal.Content>

        <Modal.Actions>
          <Link
            to={generatePath(speakingSessionDetails.absolutePath, { sessionId })}
            state={location.state}
          >
            <Button compact type="reset" secondary>
              Cancel
            </Button>
          </Link>

          <Button
            compact
            color="red"
            onClick={() => {
              removeSession({ speakingSessionId: sessionId });
            }}
            loading={isConfirming}
            disabled={isConfirming}
          >
            Remove
          </Button>
        </Modal.Actions>
      </Modal>
    </ErrorsContextProvider>
  );
};

const S = {
  ValidationErrors: styled(ValidationErrors)`
    &.ui.error.message {
      margin-bottom: 3rem;
    }
  `,
};
